export default __webpack_public_path__ + "static/media/Services.d7203246.svg";